import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import AdSense from "../AdSense";

const XIcon = (props) => (
    <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        fill="currentColor"
        width="1em"
        height="1em"
        {...props}
    >
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

function Footer() {
    return (
        <footer className="text-slate-500 text-xs mt-16 pb-8 pt-4 border-t border-slate-800/50 flex flex-col items-center gap-4">
            {/* Footer Banner Ad */}
            <div className="w-full max-w-2xl mb-4">
                <AdSense
                    adSlot="8551900988"
                    adFormat="horizontal"
                    style={{ minHeight: '90px' }}
                />
            </div>
            <div className="flex justify-center items-center gap-6">
                <a
                    href="https://x.com/michaelpdisanto"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-slate-300 transition"
                    aria-label="X (formerly Twitter)"
                >
                    <XIcon style={{ fontSize: "1.1rem" }} />
                </a>
                <a
                    href="https://github.com/mdisant"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-slate-300 transition"
                    aria-label="GitHub"
                >
                    <GitHubIcon fontSize="small" />
                </a>
            </div>

            <div className="flex flex-col items-center gap-2">
                <p className="text-center">
                    A free daily word puzzle game for NFL, NBA & MLB fans
                </p>
                <div className="flex flex-wrap justify-center gap-3">
                    <a
                        href="/about.html"
                        className="hover:text-slate-300 transition border-b border-transparent hover:border-slate-300"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        About
                    </a>
                    <span>&middot;</span>
                    <a
                        href="/faq.html"
                        className="hover:text-slate-300 transition border-b border-transparent hover:border-slate-300"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        FAQ
                    </a>
                    <span>&middot;</span>
                    <a
                        href="/privacy.html"
                        className="hover:text-slate-300 transition border-b border-transparent hover:border-slate-300"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy
                    </a>
                    <span>&middot;</span>
                    <a
                        href="/terms.html"
                        className="hover:text-slate-300 transition border-b border-transparent hover:border-slate-300"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms
                    </a>
                </div>
                <p className="text-slate-600 mt-2">
                    &copy; {new Date().getFullYear()} Sports Connections. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;
